'use client';

import { inter500 } from '@/config/fonts';
import { Agent } from '@/containers/Agents/types';
import CanvasserAvatar from '@/containers/Canvassers/components/CanvasserAvatar';
import classNames from 'classnames';
import { HTMLAttributes, ReactNode } from 'react';

interface AgentItemViewProps extends HTMLAttributes<HTMLDivElement> {
  data: Agent;
  actions?: ReactNode;
}

const AgentItemView = ({ className, data, actions, style }: AgentItemViewProps) => {
  return (
    <div
      className={classNames('flex items-center justify-between', className)}
      style={style}>
      <div className="flex w-full gap-3">
        <CanvasserAvatar
          canvasserId={data.id}
          canvasserName={data.display_name}
          size="md"
          className="shrink-0"
        />
        <div className="flex flex-1 flex-col gap-0.5">
          <span className={classNames(inter500.className)}>{data.display_name}</span>
          <span className={classNames('text-gray-default text-[13px]')}>
            {data.display_email}
          </span>
        </div>
        <div className="actions flex shrink-0 items-center gap-2">{actions}</div>
      </div>
    </div>
  );
};

export default AgentItemView;
